import RegisterAccess from '../../utils/registerAccess';
import MenuControlGeral from './menuControlGeral';
import DashboardStats from './DashboardStats';
import DashboardProdutoControladoStats from './DashboardProdutoControladoStats';
// import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const DASHBOARD_META = {
  licenciamento: {
    title: 'Dashboard - Licenciamento',
    subtitle: 'Área de Licenciamento · ARMED',
    accessPage: 'dashboard-licenciamento',
    showStats: true,
  },
  'produto-controlado': {
    title: 'Dashboard - Produto Controlado',
    subtitle: 'Área de Produto Controlado · ARMED',
    accessPage: 'dashboard-produto-controlado',
    showStats: true,
  },
  importacao: {
    title: 'Dashboard - Importação',
    subtitle: 'Área de Importação · ARMED',
    accessPage: 'dashboard-importacao',
    showStats: false,
  },
  desalfandegamento: {
    title: 'Dashboard - Desalfandegamento',
    subtitle: 'Área de Desalfandegamento · ARMED',
    accessPage: 'dashboard-desalfandegamento',
    showStats: false,
  },
  expediente: {
    title: 'Dashboard - Expediente',
    subtitle: 'Área de Expediente · ARMED',
    accessPage: 'dashboard-expediente',
    showStats: false,
  },
  'controlo-qualidade': {
    title: 'Dashboard - Controlo de Qualidade',
    subtitle: 'Área de Controlo de Qualidade · ARMED',
    accessPage: 'dashboard-controlo-qualidade',
    showStats: false,
  },
  farmacovigilancia: {
    title: 'Dashboard - Farmacovigilância',
    subtitle: 'Área de Farmacovigilância · ARMED',
    accessPage: 'dashboard-farmacovigilancia',
    showStats: false,
  },
  'registo-medicamento': {
    title: 'Dashboard - Registo de Medicamento',
    subtitle: 'Área de Registo de Medicamento · ARMED',
    accessPage: 'dashboard-registo-medicamento',
    showStats: false,
  },
};

export default function Dashboard() {
//   const user = useSelector(state => state.account.user);
  const { area } = useParams();
  const hora = new Date().getHours();
//   const saudacao = hora < 12 ? 'Bom dia' : hora < 18 ? 'Boa tarde' : 'Boa noite';

  const dashboardKey = area || 'licenciamento';
  const dashboardMeta = DASHBOARD_META[dashboardKey] || {
    title: 'Dashboard',
    subtitle: 'ARMED',
    accessPage: `dashboard-${dashboardKey}`,
    showStats: false,
  };

  return (
    <div className="tw-max-w-6xl tw-mx-auto tw-px-4 tw-pb-12">
      <RegisterAccess page={dashboardMeta.accessPage} />

      {/* Cabeçalho do dashboard */}
      <div className="tw-pt-4 tw-pb-6 tw-flex tw-items-center tw-justify-between">
        <div>
          {/* <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800">
            {saudacao}, {user?.dadosPessoais?.nome?.split(' ')[0] ?? ''} 
          </h1>
          <p className="tw-text-sm tw-text-gray-500 tw-mt-0.5">
            {user?.funcao} · {user?.departamento} · ARMED
          </p> */}
            <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800">
              {dashboardMeta.title}
            </h1>
            <p className="tw-text-sm tw-text-gray-500 tw-mt-0.5">
              {dashboardMeta.subtitle}
            </p>
            
        </div>
        <div className="tw-text-right tw-hidden md:tw-block">
          <p className="tw-text-xs tw-text-gray-400 tw-font-medium">
            {new Date().toLocaleDateString('pt-AO', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>
      </div>

      {dashboardMeta.showStats ? (
        <>
          {dashboardKey === 'licenciamento' && (
            <>
              {/* KPI Cards + Gráficos */}
              <DashboardStats />

              {/* Mapa de Províncias */}
              <div className="tw-mt-6">
                <MenuControlGeral />
              </div>
            </>
          )}

          {dashboardKey === 'produto-controlado' && <DashboardProdutoControladoStats />}
        </>
      ) : (
        <div className="tw-mt-6 tw-rounded-xl tw-border tw-border-dashed tw-border-gray-300 tw-bg-white tw-p-6 tw-text-sm tw-text-gray-600">
          Esta dashboard está preparada para a área <strong>{dashboardKey}</strong>. A estrutura de navegação já está ativa, mas os dados específicos ainda não foram ligados a este módulo.
        </div>
      )}
    </div>
  );
}
